import { Link, useLocation } from 'react-router-dom';
import { movieCategories } from '@/mocks/movies';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const breadcrumbs: BreadcrumbItem[] = [{ label: '首页', to: '/' }];

  if (pathSegments[0] === 'category' && pathSegments[1]) {
    const cat = movieCategories.find(c => c.slug === pathSegments[1]);
    breadcrumbs.push({
      label: cat ? cat.name : '电影分类',
      to: `/category/${pathSegments[1]}`,
    });
  } else if (pathSegments[0] === 'movie' && pathSegments[1]) {
    breadcrumbs.push({
      label: '电影详情',
    });
  } else if (pathSegments[0] === 'about') {
    breadcrumbs.push({ label: '关于我们' });
  }

  if (breadcrumbs.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
        {breadcrumbs.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            {index > 0 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
            {item.to && index < breadcrumbs.length - 1 ? (
              <Link to={item.to} className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className={index === breadcrumbs.length - 1 ? 'text-foreground-700 font-medium' : ''}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}